import { BrowserRouter, Route, Switch } from "react-router-dom";
import { APP_NAME, IS_APP_PRODUCTION } from "./constants/app";
import App from "./view";
import PrivacyTerm from "./view/static/PrivacyTerm";

export default function Routes() {
  return (
    <BrowserRouter basename={IS_APP_PRODUCTION ? `/` : APP_NAME}>
      <Switch>
        <Route path="/privacy-terms" component={PrivacyTerm} />
        <App />
      </Switch>
    </BrowserRouter>
  );
}
